import accountSettings from './accountSettings.json'
import ai from './ai.json'
import aiDetection from './aiDetection.json'
import analysis from './analysis.json'
import app from './app.json'
import area from './area.json'
import auth from './auth.json'
import clip from './clip.json'
import common from './common.json'
import companySettings from './companySettings.json'
import device from './device.json'
import firmware from './firmware.json'
import handsLicense from './handsLicense.json'
import map from './map.json'
import patlite from './patlite.json'
import recording from './recording.json'
import shared from './shared.json'
import stream from './stream.json'
import tag from './tag.json'
import user from './user.json'
import viewer from './viewer.json'

/**
 * 英語カタログ（TM-674）。
 *
 * `ja/index.ts` と違い手で管理する。名前空間の JSON を足したらここへ import を足す
 * （`scripts/i18n-check.js` が import 漏れをエラーにする）。
 *
 * termsOfUse / privacyPolicy は法務文書のため英訳しない
 * （`docs/i18n/catalog_policy.json`）。英語表示でも fallbackLng の日本語が出る。
 */
export const en = {
  accountSettings,
  ai,
  aiDetection,
  analysis,
  app,
  area,
  auth,
  clip,
  common,
  companySettings,
  device,
  firmware,
  handsLicense,
  map,
  patlite,
  recording,
  shared,
  stream,
  tag,
  user,
  viewer
}
